export enum response {
  success = 0,
  networkError = -1,
  canceled = -2,
  failed = -3,
  authDenied = -4,
  unsupported = -5,
}
